module.exports = __webpack_public_path__ + "img/agents_state_de.97911ced.svg";